import {legacyPermissionsEnabled} from '@netx/core-permissions-next/enablers';
import {type ISystemGroup, GroupType} from '../schema';
import {canManageSystemGroups} from './canManageSystemGroups';

export const canManageSystemGroupUsers = (group?: Pick<ISystemGroup, 'type'>) =>
	!!group &&
	group.type !== GroupType.EVERYONE &&
	(!legacyPermissionsEnabled() || group.type !== GroupType.ADMIN) &&
	canManageSystemGroups();
